import { render, staticRenderFns } from "./CompanyOffices.vue?vue&type=template&id=9242fab8&"
import script from "./CompanyOffices.vue?vue&type=script&lang=ts&"
export * from "./CompanyOffices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports